// Copyright (c) 2021 Deere & Company

import actions from '../actions-list';
import {getDefaultState} from '../state';

const updateDealershipVisibility = (state, action) => action.isVisible;

export default (state = getDefaultState().isDealershipModalOpen, action) => {

    const actionTypes = {
        [actions.IS_DEALERSHIP_MODAL_VISIBLE]: updateDealershipVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-change/reducers/is-dealership-modal-open.js